"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUploadedRxDetails = getUploadedRxDetails;
exports.uploadRXAllDocuments = uploadRXAllDocuments;
exports.uploadRXDeleteAeDocument = uploadRXDeleteAeDocument;
exports.uploadRXDeleteDocument = uploadRXDeleteDocument;
exports.uploadRXDeleteDocumentV1 = uploadRXDeleteDocumentV1;
exports.uploadRXPatientDocument = uploadRXPatientDocument;
exports.uploadRXPatientDocumentV1 = uploadRXPatientDocumentV1;
exports.uploadRXSupportTicket = uploadRXSupportTicket;
exports.uploadRXSupportTicketV1 = uploadRXSupportTicketV1;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */
// import { apiCall } from '../../../common/api/api';

function uploadRXPatientDocument(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.UPLOAD_RX_PATIENT_DOCUMENT_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function uploadRXPatientDocumentV1(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.INSTORE_ORDER_BASE_URL}${_ApiConst.UPLOAD_RX_PATIENT_DOCUMENT_API_V1}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams === null || requestParams === void 0 ? void 0 : requestParams.body;
  options.method = _ApiConst.API_PARAMS.POST;
  options.isMultipartRequest = true;
  const formData = requestParams.body;
  if (requestParams !== null && requestParams !== void 0 && requestParams.erxId) {
    options.headers = {
      ...options.headers,
      erxId: requestParams === null || requestParams === void 0 ? void 0 : requestParams.erxId
    };
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    formData
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function uploadRXAllDocuments(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.UPLOAD_RX_ALL_DOCUMENT_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function uploadRXDeleteDocument(requestParams, tokenData) {
  let apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.UPLOAD_RX_PATIENT_DOCUMENT_API}`;
  apiEndPoint = apiEndPoint + `/${requestParams.documentId}?appointmentId=NA`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function uploadRXDeleteAeDocument(requestParams, tokenData) {
  const {
    erxId = '',
    documentId = ''
  } = requestParams;
  const apiEndPoint = `${_ApiConst.INSTORE_ORDER_BASE_URL}/v1/${erxId}/${documentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function uploadRXDeleteDocumentV1(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.INSTORE_ORDER_BASE_URL}/v1/${requestParams === null || requestParams === void 0 ? void 0 : requestParams.erxId}/${requestParams === null || requestParams === void 0 ? void 0 : requestParams.documentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.DELETE });
}
function uploadRXSupportTicket(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.UPLOAD_RX_SUPPORT_TICKET_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function uploadRXSupportTicketV1(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.INSTORE_ORDER_BASE_URL}/v1/${requestParams === null || requestParams === void 0 ? void 0 : requestParams.erxID}/submit`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams === null || requestParams === void 0 ? void 0 : requestParams.body;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function getUploadedRxDetails(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.INSTORE_ORDER_BASE_URL}/v1/${requestParams.erxId}/details`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams.params;
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}